export const colors = {
  yellow: '#FFCF3F',
  gold: '#E6A519',
  brown: '#694D23',
  darkBrown: '#382D1A',
  black: '#0F0F0F',
  green: '#00FF00',
  red: '#FF0000',
  blue: '#0088FF',
  chat: '#00FFFF',
  background: '#2E2C29',
  border: '#474745',
  panel: '#46433A',
  stone: '#3E3530',
  stoneHighlight: '#6B5840',
  stoneShadow: '#1C1612',
  chatStone: '#C4B48C',
  interfaceText: '#F5E20D',
};

export const spacing = {
  xxs: '4px',
  xs: '8px',
  sm: '12px',
  md: '16px',
  lg: '24px',
  xl: '32px',
  xxl: '48px',
};

export const borderWidth = {
  thin: '1px',
  regular: '2px',
  thick: '3px',
  extraThick: '4px',
};

export const borderRadius = {
  none: '0',
  small: '2px',
  medium: '4px',
  large: '8px',
};

export const typography = {
  fontFamily: {
    main: 'RuneScape, Arial, sans-serif',
  },
  fontSize: {
    xs: '12px',
    sm: '14px',
    md: '16px',
    lg: '20px',
    xl: '24px',
    xxl: '32px',
  },
  fontWeight: {
    normal: 400,
    bold: 700,
  },
  lineHeight: {
    tight: 1,
    normal: 1.2,
    loose: 1.5,
  },
};

export const shadows = {
  none: 'none',
  small: '0 1px 2px rgba(0, 0, 0, 0.5)',
  medium: '0 2px 4px rgba(0, 0, 0, 0.6)',
  large: '0 4px 8px rgba(0, 0, 0, 0.7)',
};

export const transitions = {
  fast: '100ms',
  normal: '200ms',
  slow: '300ms',
};

const tokens = {
  colors,
  spacing,
  borderWidth,
  borderRadius,
  typography,
  shadows,
  transitions,
};

export default tokens;
